import { SimpleListProps } from "../SimpleList.types";

export type GetFinalRenderFunctionParams<T> = Pick<SimpleListProps<T>, "children" | "renderItem">;
export type GetFinalRenderFunctionReturn<T> = SimpleListProps<T>["renderItem"];

export default function getFinalRenderListFunction<T>({ children, renderItem }: GetFinalRenderFunctionParams<T>) {
    const isChildrenFunction = typeof children === "function";
    return renderItem || (isChildrenFunction ? children : undefined);
}
